import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function EquipList(){

  const [eqpviewData, seteqpviewData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetcheqpviewData();
  }, []);

  function fetcheqpviewData() {
        setIsLoading(true);
        axios.get(`${baseUrl}eqp-search/?totqty=gt0`)
          .then(response => {
            seteqpviewData(response.data);
            setIsLoading(false);
          })
          .catch(error => {
            console.log(error);
            setIsLoading(false);
          });
  }

    const columns = [
        {field:'id', headerName:'ID',width: 60},
        {
          field: 'cat',
          headerName: 'Eqp Cat',
          width: 150,
          renderCell: (params) => {
            return params.row.subcat?.cat?.category;
          }
        },
        {
          field: 'subcat',
          headerName: 'Eqp Subcat',
          width: 150,
          renderCell: (params) => {
            return params.row?.subcat?.subcat;
          }
        },
        {
          field: 'product',
          headerName: 'Product',
          width: 290,
          renderCell: (params) => {
            return params.row.product;
          }
        },
        {
          field: 'supplier',
          headerName: 'Supplier',
          width: 150,
          renderCell: (params) => {
            return params.row.supp?.name;
          }
        },
        {field:'pack', headerName:'Pack', width:10},
        {field:'totqty', headerName:'TQty', width:50},
        {field:'mrp', headerName:'MRP', width:80},
        {field:'sgst', headerName:'SGST', width:50},
        {field:'uamount', headerName:'Unit Price', width:80},
        { field: 'action', headerName: 'Action',
          renderCell: (params) => (
              <Link target="_blank" to={`/edit-eqp/${params.row.id}/`} className="btn btn-warning">
                Edit
              </Link>
          ),
        width: 80,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        },
      ];
    return (
    <section className="container mt-4">
    <div className="row">
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
          <i className="fa-solid fa-list" aria-hidden="true" style={{ color: 'red' }}></i>
          Equipment List
    </h3>
    {!isLoading && eqpviewData.length > 0 ? (
        <div style={{ height: '100%', width: '100%' }} className="mt-4">
            <DataGrid
            sx={{
            boxShadow: 4,
            border: 4,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            }}
            rows= {eqpviewData}
            columns= {columns}
            pageSize= {10}
            slots={{ toolbar: GridToolbar }}
            autoHeight
            />
        </div>
    ) : (
      <>loading pls wait....</>
    )}
    </div>
    </section>
    )
}

export default EquipList;
